export default __webpack_public_path__ + "static/media/(11).9d2a24ef.jpg";